import { Star, Quote } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { REVIEWS } from "../constants/content";

export const Testimonials = () => (
    <section id="reviews" className="relative bg-[#F4F4F2] border-y border-[#E3E3DE] noise-overlay">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-24 lg:py-32">
            <Reveal className="max-w-2xl">
                <Eyebrow>What our clients have to say</Eyebrow>
                <h2 className="mt-4 font-display font-extrabold uppercase tracking-tight text-2xl sm:text-3xl lg:text-4xl text-[#141721] leading-tight">
                    Trusted across <span className="text-[#FF3B30]">Toronto &amp; the GTA.</span>
                </h2>
            </Reveal>

            <div className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
                {REVIEWS.map((review, i) => (
                    <Reveal key={review.author} delay={(i % 3) * 0.12}>
                        <figure
                            data-testid={`review-card-${i}`}
                            className="relative h-full rounded-lg border border-[#E3E3DE] bg-white p-8 transition-all duration-500 hover:border-[#FF3B30]/60 hover:-translate-y-1"
                        >
                            <Quote className="h-7 w-7 text-[#FF3B30]" strokeWidth={1.6} />
                            <div className="mt-4 flex gap-1">
                                {Array.from({ length: 5 }).map((_, s) => (
                                    <Star
                                        key={s}
                                        className="h-4 w-4 fill-[#FF3B30] text-[#FF3B30]"
                                    />
                                ))}
                            </div>
                            <blockquote className="mt-4 text-sm text-[#565B6B] leading-relaxed">
                                “{review.text}”
                            </blockquote>
                            <figcaption className="mt-6 border-t border-[#E3E3DE] pt-4">
                                <span className="block font-display font-bold text-[#141721] text-sm">
                                    {review.author}
                                </span>
                                <span className="font-mono-ind text-[11px] uppercase tracking-widest text-[#6B7280]">
                                    {review.area}
                                </span>
                            </figcaption>
                        </figure>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
